import { isEmpty } from "lodash";
import React, { useMemo } from "react";
import { columnRenderArrayData } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import CybeatsCredentialsForm from "./CybeatsCredentialsForm";
import CybeatsMappingForm from "./CybeatsMappingForm";

const CybeatsConfigLising = (props) => {
  const columns = useMemo(
    () => [
      {
        title: "Product",
        dataIndex: "productName",
        width: 130,
        render: columnRenderArrayData,
      },
      {
        title: "Versions",
        dataIndex: "versions",
        width: 130,
        render: (versionId) =>
          isEmpty(versionId) ? "All" : columnRenderArrayData(versionId),
      },
    ],
    [],
  );

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={CybeatsMappingForm}
      CredentialsForm={CybeatsCredentialsForm}
      extraColumns={columns}
    />
  );
};

export default CybeatsConfigLising;